module.exports = __webpack_public_path__ + "img/4e05cf3.jpg";